import React, { useState } from "react";
import AtlasHeader from "@/components/atlas/AtlasHeader";
import AtlasHero from "@/components/atlas/AtlasHero";
import AtlasFeatures from "@/components/atlas/AtlasFeatures";
import AtlasWhatIs from "@/components/atlas/AtlasWhatIs";
import AtlasFAQ from "@/components/atlas/AtlasFAQ";
import AtlasHowItWorks from "@/components/atlas/AtlasHowItWorks";
import AtlasChecklistsTable from "@/components/atlas/AtlasChecklistsTable";
import AtlasAreas from "@/components/atlas/AtlasAreas";
import AtlasOffline from "@/components/atlas/AtlasOffline";
import AtlasMetrics from "@/components/atlas/AtlasMetrics";
import AtlasShowcase from "@/components/atlas/AtlasShowcase";
import AtlasCases from "@/components/atlas/AtlasCases";
import AtlasSectors from "@/components/atlas/AtlasSectors";
import AtlasTestimonials from "@/components/atlas/AtlasTestimonials";
import AtlasFinalCTA from "@/components/atlas/AtlasFinalCTA";
import AtlasFooter from "@/components/atlas/AtlasFooter";
import DemoModal from "@/components/atlas/DemoModal";
import WhatsAppFloat from "@/components/atlas/WhatsAppFloat";
import MobileStickyCTA from "@/components/atlas/MobileStickyCTA";
import { useUtmParams } from "@/hooks/useUtmParams";

export default function AtlasLanding() {
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo = () => setDemoOpen(true);

  useUtmParams();

  return (
    <div
      className="min-h-screen bg-white text-slate-900"
      data-testid="atlas-landing"
    >
      <AtlasHeader onRequestDemo={openDemo} />

      <main className="pb-20 lg:pb-0">
        <AtlasHero onRequestDemo={openDemo} />
        <AtlasFeatures />
        <AtlasWhatIs />
        <AtlasFAQ />
        <AtlasHowItWorks />
        <AtlasAreas />
        <AtlasChecklistsTable />
        <AtlasMetrics />
        <AtlasShowcase onRequestDemo={openDemo} />
        <AtlasOffline />
        <AtlasCases />
        <AtlasSectors />
        <AtlasTestimonials />
        <AtlasFinalCTA onRequestDemo={openDemo} />
      </main>

      <AtlasFooter />

      <WhatsAppFloat />
      <MobileStickyCTA onRequestDemo={openDemo} />

      <DemoModal open={demoOpen} onOpenChange={setDemoOpen} />
    </div>
  );
}
